import * as React from 'react';
import { LineChart } from '@mui/x-charts/LineChart';
import { axisClasses } from '@mui/x-charts';

interface SemesterData {
    semester: string;
    averageGrade: number;
}

interface Props {
    data: SemesterData[];
}

export default function BieuDoHocKy({ data }: Props) {
    return (
        <LineChart
            width={500}
            height={300}
            xAxis={[{ scaleType: 'point', data: data.map((d) => d.semester) }]}
            series={[
                {
                    data: data.map((d) => d.averageGrade),
                    label: 'Điểm trung bình',
                    color: '#8884d8'
                }
            ]}
            sx={{
                [`& .${axisClasses.tickLabel}`]: {
                    fontSize: 12
                }
            }}
        />
    );
}
